import { useCallback, useEffect, useMemo, useState } from 'react';
import PaymentsPopup from '../Payments/PaymentsPopup';
import { getString } from '../../../strings';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledButton } from '../../atoms/Button/StyledButton';
import { BigLoader } from '../../atoms/Loader/StyledBigLoader';
import { StyledInputsDivWrapper } from '../../atoms/StyledInputsDivWrapper/StyledInputsDivWrapper';
import { StyledEditInputElement, StyledInputWrapper } from '../../../styles/sharedStyles';
import { downloadIDCards } from './UserPanelTournament.data';
import {
    getEventRoles,
    getPeopleWithFreeRegistration,
    updateEventRoles,
} from '../../../logic/requests/events';

const GetIdsModal = ({ eventData, onClose }) => {
    const [idCardsDownloaded, setIdCardsDownloaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [usersWithFreeRegistrations, setUsersWithFreeRegistrations] = useState([]);
    const [savedRolesSuccesfully, setSavedRolesSuccesfully] = useState(false);
    const [listUsers, setListUsers] = useState([]);
    const [eventRoles, setEventRoles] = useState([]);

    const onSubmit = useCallback(() => {
        setIsLoading(true);
        setIdCardsDownloaded(false);
        downloadIDCards(
            eventData.code,
            listUsers.map((user) => ({
                id: Math.floor(Math.random() * 1000000),
                firstname: user.name.split(' ')[0] || '',
                lastname: user.name.split(' ')[1] || '',
                avatar: null,
                wca_id: null,
                role: user.role,
            }))
        ).then(() => {
            setIsLoading(false);
            setIdCardsDownloaded(true);
        });
    }, [eventData, listUsers]);

    const getUsersWithFreeRegistrations = useCallback(() => {
        getPeopleWithFreeRegistration(eventData.id).then((res) => {
            setUsersWithFreeRegistrations(
                res.people.map((user) => ({
                    ...user,
                    role: user.role || '',
                }))
            );
        });
    }, [eventData.id]);

    const fetchEventRoles = useCallback(() => {
        getEventRoles().then((res) => {
            setEventRoles(res.roles);
        });
    }, []);

    const handleAddUser = useCallback(() => {
        setListUsers((prevListUsers) => [
            ...prevListUsers,
            {
                index: prevListUsers.length + 1,
                name: '',
                role: 'judge',
            },
        ]);
    }, []);

    const handleDeleteUser = useCallback(() => {
        setListUsers((prevListUsers) => prevListUsers.slice(0, prevListUsers.length - 1));
    }, []);

    const handleRoleChange = (userId, newRole) => {
        setUsersWithFreeRegistrations((users) =>
            users.map((user) => (user.id === userId ? { ...user, role: newRole } : user))
        );
    };

    const saveRoles = useCallback(() => {
        setSavedRolesSuccesfully(false);
        updateEventRoles(eventData.id, {
            registrations: usersWithFreeRegistrations.map((user) => ({
                userId: user.id,
                roleId: user.role,
            })),
        })
            .then(() => {
                setSavedRolesSuccesfully(true);
            })
            .catch((err) => {
                console.error('Error saving roles:', err);
            });

        setTimeout(() => {
            setSavedRolesSuccesfully(false);
        }, 2000);
    }, [eventData.id, usersWithFreeRegistrations]);

    useEffect(() => {
        getUsersWithFreeRegistrations();
    }, [getUsersWithFreeRegistrations]);

    useEffect(() => {
        fetchEventRoles();
    }, [fetchEventRoles]);

    const renderContent = useMemo(
        () =>
            idCardsDownloaded ? (
                <div>
                    <StyledText
                        hasdeclaredfontsize="18px"
                        hasdeclaredpadding={'50px 20px 20px 20px'}
                        hasdeclaredlineheight="1.4em"
                        hasdeclaredtextalign="center"
                    >
                        {getString('userPanel_userPanelTournament_get_ids_downloaded')}
                    </StyledText>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredbgcolor="#6786BE"
                            hasdeclaredpadding="0 28px"
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredborderradius="25px"
                            hasdeclaredfontweight="700"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredfontsize="18px"
                            hasdeclaredtexttransform="uppercase"
                            hasdeclaredheight="50px"
                            hasdeclaredmargin="20px auto 0"
                            onClick={onClose}
                        >
                            {getString('all_trainer_pay_popup_zamknij')}
                        </StyledButton>
                    </div>
                </div>
            ) : isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <BigLoader />
                </div>
            ) : (
                <>
                    <StyledText
                        hasdeclaredfontsize="18px"
                        hasdeclaredpadding={'40px 20px 20px 20px'}
                        hasdeclaredlineheight="1.4em"
                        hasdeclaredtextalign="center"
                    >
                        {getString('userPanel_userPanelTournament_get_ids_title')}
                    </StyledText>

                    <StyledInputsDivWrapper>
                        <StyledInputWrapper>
                            <label>
                                <StyledText
                                    hasdeclaredfontsize="20px"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredpadding="8px 0 15px 0"
                                    hasdeclaredfontweight="600"
                                >
                                    {getString(
                                        'userPanel_userPanelTournament_get_ids_free_registrations'
                                    )}
                                </StyledText>
                            </label>
                        </StyledInputWrapper>
                    </StyledInputsDivWrapper>
                    <div>
                        {usersWithFreeRegistrations.map((user) => (
                            <div
                                key={user.id}
                                style={{ display: 'flex', justifyContent: 'center', gap: 10 }}
                            >
                                <StyledText
                                    hasdeclaredfontsize="18px"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredpadding="8px 0 0 0"
                                    hasdeclaredfontweight="500"
                                >
                                    {user.firstname} {user.lastname}
                                </StyledText>
                                <StyledEditInputElement $hasDeclaredWidth="30%">
                                    <select
                                        value={user.role || ''}
                                        onChange={(e) => handleRoleChange(user.id, e.target.value)}
                                    >
                                        {eventRoles.map((role) => (
                                            <option key={role} value={role}>
                                                {role}
                                            </option>
                                        ))}
                                    </select>
                                </StyledEditInputElement>
                            </div>
                        ))}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={saveRoles}
                        >
                            {getString('userPanel_userPanelTournament_get_ids_save_roles')}
                        </StyledButton>
                    </div>
                    {savedRolesSuccesfully && (
                        <StyledText
                            hasdeclaredfontsize="16px"
                            hasdeclaredtextalign="center"
                            hasdeclaredpadding="8px 0 0 0"
                            hasdeclaredfontweight="500"
                            hasdeclaredcolor="#28a745"
                        >
                            {getString('userPanel_userPanelTournament_get_ids_roles_saved')}
                        </StyledText>
                    )}
                    <StyledInputsDivWrapper>
                        <StyledInputWrapper>
                            <label>
                                <StyledText
                                    hasdeclaredfontsize="20px"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredpadding="15px 0 15px 0"
                                    hasdeclaredfontweight="600"
                                >
                                    {getString(
                                        'userPanel_userPanelTournament_get_ids_additional_ids'
                                    )}
                                </StyledText>
                            </label>
                        </StyledInputWrapper>
                    </StyledInputsDivWrapper>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="0 0 20px 0"
                            hasdeclaredfontweight="600"
                            onClick={handleAddUser}
                        >
                            {getString('userPanel_userPanelTournament_get_thanks_add')}
                        </StyledButton>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#ee745c"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="0 0 20px 0"
                            hasdeclaredfontweight="600"
                            onClick={handleDeleteUser}
                        >
                            {getString('userPanel_userPanelTournament_get_thanks_remove')}
                        </StyledButton>
                    </div>
                    {listUsers.map((user) => (
                        <StyledInputsDivWrapper key={user.index}>
                            <StyledInputWrapper hasdeclaredwidth="40%">
                                <input
                                    name={`name_${user.index}`}
                                    value={user.name}
                                    onChange={(e) => {
                                        const updatedList = listUsers.map((u) =>
                                            u.index === user.index
                                                ? { ...u, name: e.target.value }
                                                : u
                                        );
                                        setListUsers(updatedList);
                                    }}
                                    as="input"
                                    type="text"
                                />
                            </StyledInputWrapper>
                            <StyledInputWrapper hasdeclaredwidth="40%">
                                <StyledEditInputElement $hasDeclaredWidth="100%">
                                    <select
                                        value={user.role || ''}
                                        onChange={(e) => {
                                            const updatedList = listUsers.map((u) =>
                                                u.index === user.index
                                                    ? { ...u, role: e.target.value }
                                                    : u
                                            );
                                            setListUsers(updatedList);
                                        }}
                                    >
                                        {eventRoles.map((role) => (
                                            <option key={role} value={role}>
                                                {role}
                                            </option>
                                        ))}
                                    </select>
                                </StyledEditInputElement>
                            </StyledInputWrapper>
                        </StyledInputsDivWrapper>
                    ))}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={onSubmit}
                        >
                            {getString('userPanel_userPanelTournament_get_thanks_download')}
                        </StyledButton>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#ee745c"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 40px 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={onClose}
                        >
                            {getString('userPanel_userPanelTournament_payment_reminder_cancel')}
                        </StyledButton>
                    </div>
                </>
            ),
        [
            idCardsDownloaded,
            onClose,
            isLoading,
            usersWithFreeRegistrations,
            saveRoles,
            savedRolesSuccesfully,
            handleAddUser,
            handleDeleteUser,
            listUsers,
            onSubmit,
            eventRoles,
        ]
    );

    return <PaymentsPopup>{renderContent}</PaymentsPopup>;
};

export default GetIdsModal;
